import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useRef } from 'react';
import { useLoadWidget, propsBoolean, propsObject } from '../utils';
import { SgwtWidgetContext } from '../context';
const name = 'sgwt-account-center';
export const SgwtAccountCenter = ({ availableLanguages, authentication, debug, environment, hideServicesLink, i18n, language, mode, navigateAs, navigateAsList, navigateAsUser, producerCode, showLanguagesSelection, showPersonalisation, showSignInButton, themeSwitcher, user, userDropdownLinks, onLanguageChanged, onNavigateAsLinkClicked, onNavigateAsSelectUser, onStopNavigationAs, onSignInRequest, onSignIn, onSignOut, onDropdownLinkClicked, onThemeChanged, id, onWidgetReady, }) => {
    const widget = useRef();
    const { infrastructure } = useContext(SgwtWidgetContext);
    useLoadWidget(name, infrastructure);
    useEffect(() => {
        if (!!widget.current) {
            onWidgetReady?.(widget.current);
        }
    }, [widget, onWidgetReady]);
    // ---- [EVENTS] Language changed ----
    useEffect(() => {
        const eventName = `${name}--language-changed`;
        const languageChanged = (evt) => onLanguageChanged?.(evt.detail.language);
        document.addEventListener(eventName, languageChanged);
        return () => document.removeEventListener(eventName, languageChanged);
    }, [onLanguageChanged]);
    // ---- [EVENTS] Navigation As ----
    useEffect(() => {
        const eventName = `${name}--navigate-as-link-clicked`;
        const navigateAsLinkClicked = () => onNavigateAsLinkClicked?.();
        document.addEventListener(eventName, navigateAsLinkClicked);
        return () => document.removeEventListener(eventName, navigateAsLinkClicked);
    }, [onNavigateAsLinkClicked]);
    useEffect(() => {
        const eventName = `${name}--navigate-as-select-user`;
        const navigateAsSelectUser = (event) => onNavigateAsSelectUser?.(event.detail.navigateAsUser);
        document.addEventListener(eventName, navigateAsSelectUser);
        return () => document.removeEventListener(`${name}--navigate-as-select-user`, navigateAsSelectUser);
    }, [onNavigateAsSelectUser]);
    useEffect(() => {
        const eventName = `${name}--stop-navigation-as`;
        const stopNavigationAs = () => onStopNavigationAs?.();
        document.addEventListener(eventName, stopNavigationAs);
        return () => document.removeEventListener(`${name}--navigate-as-select-user`, stopNavigationAs);
    }, [onStopNavigationAs]);
    // ---- [EVENTS] Connection ----
    useEffect(() => {
        const eventName = `${name}--sign-in-request`;
        const signInRequest = () => onSignInRequest?.();
        document.addEventListener(eventName, signInRequest);
        return () => document.removeEventListener(eventName, signInRequest);
    }, [onSignInRequest]);
    useEffect(() => {
        const eventName = `${name}--sign-in`;
        const signIn = (event) => onSignIn?.(event.detail.user);
        document.addEventListener(eventName, signIn);
        return () => document.removeEventListener(eventName, signIn);
    }, [onSignIn]);
    useEffect(() => {
        const eventName = `${name}--sign-out`;
        const signOut = () => onSignOut?.();
        document.addEventListener(eventName, signOut);
        return () => document.removeEventListener(eventName, signOut);
    }, [onSignOut]);
    // [EVENTS] ---- Others ----
    useEffect(() => {
        const eventName = `${name}--user-dropdown-link-clicked`;
        const dropdownLinkClicked = (event) => onDropdownLinkClicked?.(event.detail.link);
        document.addEventListener(eventName, dropdownLinkClicked);
        return () => document.removeEventListener(eventName, dropdownLinkClicked);
    });
    useEffect(() => {
        const eventName = `${name}--theme-changed`;
        const themeChanged = (event) => onThemeChanged?.(event.detail);
        document.addEventListener(eventName, themeChanged);
        return () => document.removeEventListener(eventName, themeChanged);
    });
    return (_jsx("sgwt-account-center", { ref: widget, id: id, "available-languages": availableLanguages?.join(','), authentication: authentication ? 'sg-connect-v2' : undefined, debug: propsBoolean(debug), environment: environment, "hide-services-link": propsBoolean(hideServicesLink), i18n: i18n ? JSON.stringify(i18n) : undefined, language: language, mode: mode, "navigate-as": propsBoolean(navigateAs), "navigate-as-list": propsObject(navigateAsList), "navigate-as-user": propsObject(navigateAsUser), "producer-code": producerCode, "show-languages-selection": propsBoolean(showLanguagesSelection), "show-personalisation": propsBoolean(showPersonalisation), "show-sign-in-button": propsBoolean(showSignInButton), "theme-switcher": propsBoolean(themeSwitcher), user: propsObject(user), "user-dropdown-links": userDropdownLinks }));
};
//# sourceMappingURL=SgwtAccountCenter.js.map